import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import ProcessingIcon from 'components/icons/ProcessingIcon';
import { Spinner } from 'components/UIKit/Spinner';
import { setModal } from 'ducks/modal';
import Submission from 'components/Submission';
import { fetchQCStatus } from 'ducks/qcReports';

export default function SubmitButton({
  handleOnClick,
  isFetching,
  isDisabled,
  style,
  children,
  params,
  dispatch,
  qcErrors,
}: Object): React.Element {
  const customStyles = {
    content: {
      position: 'initial',
      bottom: 'auto',
      right: 'auto',
      left: 'auto',
      top: 'auto',
      width: '60rem',
    },
  };
  return (
    <ButtonTemplate
      style={style}
      onClick={() => {
        const { program, project } = params;
        dispatch(fetchQCStatus({
          program,
          project,
        }));

        dispatch(setModal({
          Component: () => (
            <Submission
              closeModal={() => dispatch(setModal({ Component: null }))}
              handleOnClick={handleOnClick}
              params={params}
              qcErrors={qcErrors}
              />
          ),
          style: customStyles,
        }));
      }}
      disabled={isFetching || isDisabled}
      PrefixComponent={
        isFetching
          ? <Spinner style={{ width: '14px', height: '14px', margin: '0 0.25rem' }} />
          : <ProcessingIcon style={{ margin: '0 .25rem' }} />
      }
      >
      {children || 'Submit'}
    </ButtonTemplate>
  );
}
